export default __webpack_public_path__ + "static/ContactUs-3fc1ae66d8848c5fa0f02362125ec0ab.svg";